// extracted by mini-css-extract-plugin
export default {"updateSuccessPlanModalTitle":"IxiZzjS63wE358OeYXVf","updateSuccessPlanModalDescription":"rp0FzionZgMmQjDTsgWP","updateSuccessPlanModalButtonContainer":"bw7or4v16fcfmhg9kkql"};